import React, { ReactElement } from 'react';
import { useSessionUserContext } from '../../../../../../hooks/use-session-user-context';
import { PublicIntegrationPanelContainer } from './publicContainer';
import { DCloudIntegrationPanelContainer } from './dCloudContainer';

export type IntegrationPanelContainerProps = {
  integrationType: IntegrationType;
};

export function IntegrationPanelContainer({
  integrationType,
}: IntegrationPanelContainerProps): ReactElement {
  const { accessKey, sessionUid, versionUid } = useSessionUserContext();

  if (accessKey) {
    return (
      <PublicIntegrationPanelContainer
        accessKey={accessKey}
        integrationType={integrationType}
        sessionUid={sessionUid}
        versionUid={versionUid}
      />
    );
  }
  return (
    <DCloudIntegrationPanelContainer
      integrationType={integrationType}
      sessionUid={sessionUid}
      versionUid={versionUid}
    />
  );
}
